export enum OptionsConstants {
  SET_ASSESSED_BY_OPTIONS = 'options/SET_ASSESSED_BY_OPTIONS',
  SET_METHOD_OPTIONS = 'options/SET_METHOD_OPTIONS',
  SET_SECURED_VIA_OPTIONS = 'options/SET_SECURED_VIA_OPTIONS',
  SET_VERIFIED_BY_OPTIONS = 'options/SET_VERIFIED_BY_OPTIONS',
  SET_MALLAMPATI_OPTIONS = 'options/SET_MALLAMPATI_OPTIONS',
  SET_SELLICK_MANEUVER_OPTIONS = 'options/SET_SELLICK_MANEUVER_OPTIONS',
  SET_CUFF_FILL_OPTIONS = 'options/SET_CUFF_FILL_OPTIONS',
  SET_LARYNGOSCOPE_BLADE_OPTIONS = 'options/SET_LARYNGOSCOPE_BLADE_OPTIONS',
  SET_INDICATIONS_OPTIONS = 'options/SET_INDICATIONS_OPTIONS',
  SET_AIRWAY_COMPLICATIONS_OPTIONS = 'options/SET_AIRWAY_COMPLICATIONS_OPTIONS',
  SET_PROCEDURE_COMPLICATIONS_OPTIONS = 'options/SET_PROCEDURE_COMPLICATIONS_OPTIONS',
  SET_RESPONSE_OPTIONS = 'options/SET_RESPONSE_OPTIONS',
  SET_AUTHORIZATION_OPTIONS = 'options/SET_AUTHORIZATION_OPTIONS',
  SET_DISTANCE_UNIT_OPTIONS = 'options/SET_DISTANCE_UNIT_OPTIONS',
  SET_LARYNGOSCOPIC_GRADE_OPTIONS = 'options/SET_LARYNGOSCOPIC_GRADE_OPTIONS',
  SET_RSI_PROTOCOL_OPTIONS = 'options/SET_RSI_PROTOCOL_OPTIONS',
  SET_STYLET_USED_OPTIONS = 'options/SET_STYLET_USED_OPTIONS',
  SET_VERIFICATION_VIA_OPTIONS = 'options/SET_VERIFICATION_VIA_OPTIONS',
  SET_AIRWAY_PLACEMENT_TECHNIQUE_OPTIONS = 'options/SET_AIRWAY_PLACEMENT_TECHNIQUE_OPTIONS',
  SET_CHUNKED_PATIENT_MEDICAL_HISTORY = 'options/SET_CHUNKED_PATIENT_MEDICAL_HISTORY',
  SET_TRANSFORMED_CHUNKED_PATIENT_MEDICAL_HISTORY = 'options/SET_TRANSFORMED_CHUNKED_PATIENT_MEDICAL_HISTORY',
  SET_PATIENT_MEDICAL_HISTORY = 'options/SET_PATIENT_MEDICAL_HISTORY',
  SET_FULL_PATIENT_MEDICAL_HISTORY = 'options/SET_FULL_PATIENT_MEDICAL_HISTORY',
  SET_OBTAINED_FROM_OPTIONS = 'options/SET_OBTAINED_FROM_OPTIONS',
  SET_EMERGENCY_INFO_FORM_OPTIONS = 'options/SET_EMERGENCY_INFO_FORM_OPTIONS',
  SET_MEDICATIONS_OPTIONS = 'options/SET_MEDICATIONS_OPTIONS',
  SET_COMMON_MEDICATIONS_OPTIONS = 'options/SET_COMMON_MEDICATIONS_OPTIONS',
  GET_MEDICATIONS_OPTIONS = 'options/GET_MEDICATIONS_OPTIONS',
  SET_ROUTE_OPTIONS = 'options/SET_ROUTE_OPTIONS',
  SET_ACTION_OPTIONS = 'options/SET_ACTION_OPTIONS',

  SET_DRAIN_ACTION_OPTIONS = 'options/SET_DRAIN_ACTION_OPTIONS',
  SET_DRAIN_PROCEDURE_OPTIONS = 'options/SET_DRAIN_PROCEDURE_OPTIONS',
  SET_DRAIN_SIZE_UNIT_OPTIONS = 'options/SET_DRAIN_SIZE_UNIT_OPTIONS',
  SET_DRAIN_DRAIN_SUCTION_OPTIONS = 'options/SET_DRAIN_DRAIN_SUCTION_OPTIONS',
  SET_DRAIN_CHEST_SUCTION_OPTIONS = 'options/SET_DRAIN_CHEST_SUCTION_OPTIONS',
  SET_DRAIN_FOLEY_COLOR_OPTIONS = 'options/SET_DRAIN_FOLEY_COLOR_OPTIONS',
  SET_DRAIN_CSF_COLOR_OPTIONS = 'options/SET_DRAIN_CSF_COLOR_OPTIONS',
  SET_DRAIN_SIDE_OPTIONS = 'options/SET_DRAIN_SIDE_OPTIONS',
  SET_DRAIN_LOCATION_OPTIONS = 'options/SET_DRAIN_LOCATION_OPTIONS',
  SET_DRAIN_INTERCOSTAL_SPACE_OPTIONS = 'options/SET_DRAIN_INTERCOSTAL_SPACE_OPTIONS',
  SET_ILEOSTOMY_COLOSTOMY_OPTIONS = 'options/SET_ILEOSTOMY_COLOSTOMY_OPTIONS',

  SET_LEAD_CHANGE_OPTIONS = 'options/SET_LEAD_CHANGE_OPTIONS',
  SET_DEFIB_TYPE_OPTIONS = 'options/SET_DEFIB_TYPE_OPTIONS',
  SET_TYPE_OPTIONS = 'options/SET_TYPE_OPTIONS',
  SET_BLOOD_PRESSURE_METHOD_OPTIONS = 'options/SET_BLOOD_PRESSURE_METHOD_OPTIONS',
  SET_RHYTHM_OPTIONS = 'options/SET_RHYTHM_OPTIONS',
  SET_REGULARITY_OPTIONS = 'options/SET_REGULARITY_OPTIONS',
  SET_ECG_TYPE_OPTIONS = 'options/SET_ECG_TYPE_OPTIONS',
  SET_ECG_TYPE_METHOD_OPTIONS = 'options/SET_ECG_TYPE_METHOD_OPTIONS',
  SET_GCS_OPTIONS = 'options/SET_GCS_OPTIONS',
  SET_HEART_RATE_METHODS_OPTIONS = 'options/SET_HEART_RATE_METHODS_OPTIONS',
  SET_NEUROLOC_OPTIONS = 'options/SET_NEUROLOC_OPTIONS',
  SET_TEMP_UNIT_OPTIONS = 'options/SET_TEMP_UNIT_OPTIONS',
  SET_STROKE_SCALE_OPTIONS = 'options/SET_STROKE_SCALE_OPTIONS',
  SET_STROKE_SCALE_SCORE_OPTIONS = 'options/SET_STROKE_SCALE_SCORE_OPTIONS',
  SET_RESPIRATION_RATE_EFFORT_OPTIONS = 'options/SET_RESPIRATION_RATE_EFFORT_OPTIONS',
  SET_PAIN_SCALE_OPTIONS = 'options/SET_PAIN_SCALE_OPTIONS',
  SET_WITHDRAWAL_SCALE_OPTIONS = 'options/SET_WITHDRAWAL_SCALE_OPTIONS',
  SET_WITHDRAWAL_SCALE_TYPE_OPTIONS = 'options/SET_WITHDRAWAL_SCALE_TYPE_OPTIONS',
  SET_PAIN_QUALITY_ONSET_UNIT_OPTIONS = 'options/SET_PAIN_QUALITY_ONSET_UNIT_OPTIONS',
  SET_PAIN_QUALITY_FIELD_OPTIONS = 'options/SET_PAIN_QUALITY_FIELD_OPTIONS',
  SET_SEDATION_SCALE_OPTIONS = 'options/SET_SEDATION_SCALE_OPTIONS',
  SET_ADDITIONAL_PAIN_SCALE_OPTIONS = 'options/SET_ADDITIONAL_PAIN_SCALE_OPTIONS',
  SET_TEMPERATURE_METHOD_OPTIONS = 'options/SET_TEMPERATURE_METHOD_OPTIONS',
  SET_ETCO2_TYPE_OPTIONS = 'options/SET_ETCO2_TYPE_OPTIONS',
  SET_VITALS_ASSESSED_BY_OPTIONS = 'options/SET_VITALS_ASSESSED_BY_OPTIONS',
  SET_EYE_OPENING_RESPONSE_OPTIONS = 'options/SET_EYE_OPENING_RESPONSE_OPTIONS',
  SET_VERBAL_RESPONSE_OPTIONS = 'options/SET_VERBAL_RESPONSE_OPTIONS',
  SET_MOTOR_RESPONSE_OPTIONS = 'options/SET_MOTOR_RESPONSE_OPTIONS',
  SET_PROTOCOL_OPTIONS = 'options/SET_PROTOCOL_OPTIONS',
  SET_PERFORMED_BY_OPTIONS = 'options/SET_PERFORMED_BY_OPTIONS',
  SET_MEDICATION_OPTIONS = 'options/SET_MEDICATION_OPTIONS',
  SET_DOSE_UNIT_OPTIONS = 'options/SET_DOSE_UNIT_OPTIONS',
  SET_RATE_UNIT_OPTIONS = 'options/SET_RATE_UNIT_OPTIONS',
  SET_MEDICATION_ADMINISTERED_ROUTE_OPTIONS = 'options/SET_MEDICATION_ADMINISTERED_ROUTE_OPTIONS',
  SET_FREQUENCY_OPTIONS = 'options/SET_FREQUENCY_OPTIONS',
  SET_RESPONSE_VALUE_OPTIONS = 'options/SET_RESPONSE_VALUE_OPTIONS',
  SET_COMPLICATIONS_OPTIONS = 'options/SET_COMPLICATIONS_OPTIONS',
  SET_PATIENT_ALLERGIES_OPTIONS = 'options/SET_PATIENT_ALLERGIES_OPTIONS',
  SET_PATIENT_ALLERGIES_FOOD_ENVIRONMENT_BUTTON_WALL_OPTIONS = 'options/SET_PATIENT_ALLERGIES_FOOD_ENVIRONMENT_BUTTON_WALL_OPTIONS',
  SET_PATIENT_ALLERGIES_MEDICATION_BUTTON_WALL_OPTIONS = 'options/SET_PATIENT_ALLERGIES_MEDICATION_BUTTON_WALL_OPTIONS',
  SET_BLOOD_TYPE_OPTIONS = 'options/SET_BLOOD_TYPE_OPTIONS',
  SET_COUNTRY_OPTIONS = 'options/SET_COUNTRY_OPTIONS',
  SET_DL_STATE_OPTIONS = 'options/SET_DL_STATE_OPTIONS',
  SET_EMAIL_TYPE_OPTIONS = 'options/SET_EMAIL_TYPE_OPTIONS',
  SET_SEX_OPTIONS = 'options/SET_SEX_OPTIONS',
  SET_GENDER_OPTIONS = 'options/SET_GENDER_OPTIONS',
  SET_PHONE_TYPE_OPTIONS = 'options/SET_PHONE_TYPE_OPTIONS',
  SET_RACE_OPTIONS = 'options/SET_RACE_OPTIONS',
  SET_DNR_OPTIONS = 'options/SET_DNR_OPTIONS',
  SET_BARRIERS_TO_CARE_OPTIONS = 'options/SET_BARRIERS_TO_CARE_OPTIONS',
  SET_PREFERRED_LANGUAGE_OPTIONS = 'options/SET_PREFERRED_LANGUAGE_OPTIONS',
  SET_STATE_OPTIONS = 'options/SET_STATE_OPTIONS',
  SET_PATIENT_COUNTY_OPTIONS = 'options/SET_PATIENT_COUNTY_OPTIONS',
  SET_RESIDENCE_OPTIONS = 'options/SET_RESIDENCE_OPTIONS',
  SET_ALT_HOME_RESIDENCE_OPTIONS = 'options/SET_ALT_HOME_RESIDENCE_OPTIONS',
  SET_EMPLOYER_COUNTY_OPTIONS = 'options/SET_EMPLOYER_COUNTY_OPTIONS',
  SET_PICK_UP_AND_DESTINATION_COUNTY_OPTIONS = 'options/SET_PICK_UP_AND_DESTINATION_COUNTY_OPTIONS',
  SET_SUFFIX_OPTIONS = 'options/SET_SUFFIX_OPTIONS',
  SET_TRIAGE_COLOR_OPTIONS = 'options/SET_TRIAGE_COLOR_OPTIONS',
  SET_WEIGHT_OPTIONS = 'options/SET_WEIGHT_OPTIONS',
  SET_INTERFACILITY_TRANSFER_OPTIONS = 'options/SET_INTERFACILITY_TRANSFER_OPTIONS',
  SET_HEIGHT_OPTIONS = 'options/SET_HEIGHT_OPTIONS',
  SET_AGE_OPTIONS = 'options/SET_AGE_OPTIONS',
  SET_BASE_OPTIONS = 'options/SET_BASE_OPTIONS',
  SET_UNIT_OPTIONS = 'options/SET_UNIT_OPTIONS',
  SET_STAFFING_LEVEL_OPTIONS = 'options/SET_STAFFING_LEVEL_OPTIONS',
  SET_SHIFT_OPTIONS = 'options/SET_SHIFT_OPTIONS',
  SET_REGISTRATION_TAIL_OPTIONS = 'options/SET_REGISTRATION_TAIL_OPTIONS',
  SET_DISPATCH_PRIORITY_OPTIONS = 'options/SET_DISPATCH_PRIORITY_OPTIONS',
  SET_EMD_PERFORMED_OPTIONS = 'options/SET_EMD_PERFORMED_OPTIONS',
  SET_TYPE_OF_SERVICE_OPTIONS = 'options/SET_TYPE_OF_SERVICE_OPTIONS',
  SET_STANDBY_PURPOSE_OPTIONS = 'options/SET_STANDBY_PURPOSE_OPTIONS',
  SET_SCHEDULED_OPTIONS = 'options/SET_SCHEDULED_OPTIONS',
  SET_PATIENT_CATEGORY_OPTIONS = 'options/SET_PATIENT_CATEGORY_OPTIONS',
  SET_DISPATCHED_AS_OPTIONS = 'options/SET_DISPATCHED_AS_OPTIONS',
  SET_DISPOSITION_OPTIONS = 'options/SET_DISPOSITION_OPTIONS',
  SET_AMBULANCE_TRANSPORT_CODE_OPTIONS = 'options/SET_AMBULANCE_TRANSPORT_CODE_OPTIONS',
  SET_MASS_CASUALTY_OPTIONS = 'options/SET_MASS_CASUALTY_OPTIONS',
  SET_VEHICLE_GRID_OPTIONS = 'options/SET_VEHICLE_GRID_OPTIONS',
  SET_EMS_VEHICLE_OPTIONS = 'options/SET_EMS_VEHICLE_OPTIONS',
  SET_EMS_REG_TAIL_NUMBER_OPTIONS = 'options/SET_EMS_REG_TAIL_NUMBER_OPTIONS',
  SET_CHUNKED_PATIENT_ALLERGIES = 'options/SET_CHUNK_PATIENT_ALLERGY_OPTIONS',
  SET_TRANSFORMED_CHUNKED_PATIENT_ALLERGIES = 'options/SET_TRANSFORMED_CHUNK_PATIENT_ALLERGY_OPTIONS',
  SET_LOCATION_TYPE_OPTIONS = 'options/SET_LOCATION_TYPE_OPTIONS',
  SET_IMAGING_ULTRASOUND_LOCATION_OPTIONS = 'options/SET_IMAGING_ULTRASOUND_LOCATION_OPTIONS',
  SET_IMAGING_ULTRASOUND_FINDINGS_OPTIONS = 'options/SET_IMAGING_ULTRASOUND_FINDINGS_OPTIONS',
  SET_IMAGING_ULTRASOUND_TYPE_OPTIONS = 'options/SET_IMAGING_ULTRASOUND_TYPE_OPTIONS',
  SET_OTHER_TYPE_OPTIONS = 'options/SET_OTHER_TYPE_OPTIONS',
  SET_PN_MEDICATION_VALUE_OPTIONS = 'options/SET_PN_MEDICATION_VALUE_OPTIONS',
  SET_PN_MEDICATION_MEDICATION_OPTIONS = 'options/SET_PN_MEDICATION_MEDICATION_OPTIONS',
  SET_RESPONSE_MODE_OPTIONS = 'options/SET_RESPONSE_MODE_OPTIONS',
  SET_AIRWAY_ACTION_OPTIONS = 'options/SET_AIRWAY_ACTION_OPTIONS',
  SET_AIRWAY_VIA_OPTIONS = 'options/SET_AIRWAY_VIA_OPTIONS',
  SET_AIRWAY_VERIFICATION_METHOD_OPTIONS = 'options/SET_AIRWAY_VERIFICATION_METHOD_OPTIONS',
  SET_AIRWAY_COMP_OPTIONS = 'options/SET_AIRWAY_COMP_OPTIONS',
  SET_AIRWAY_TEMPERTURE_UNIT_OPTIONS = 'options/SET_AIRWAY_TEMPERTURE_UNIT_OPTIONS',
  SET_CHILDBIRTHOB_ACTION_OPTIONS = 'options/SET_CHILDBIRTHOB_ACTION_OPTIONS',
  SET_VARIABILITY_OPTIONS = 'options/SET_VARIABILITY_OPTIONS',
  SET_ACCELERATIONS_OPTIONS = 'options/SET_ACCELERATIONS_OPTIONS',
  SET_DECELERATION_OPTIONS = 'options/SET_DECELERATION_OPTIONS',
  SET_UC_STRENGTH_OPTIONS = 'options/SET_UC_STRENGTH_OPTIONS',
  SET_DTR_OPTIONS = 'options/SET_DTR_OPTIONS',
  SET_IV_SITE_OPTIONS = 'options/SET_IV_SITE_OPTIONS',
  SET_IV_TYPE_OPTIONS = 'options/SET_IV_TYPE_OPTIONS',
  SET_IMMOBILIZATION_ASSESSMENT_OPTIONS = 'options/SET_IMMOBILIZATION_ASSESSMENT_OPTIONS',
  SET_IMMOBILIZATION_SITE_OPTIONS = 'options/SET_IMMOBILIZATION_SITE_OPTIONS',
  SET_IMMOBILIZATION_DEVICES_USED_OPTIONS = 'options/SET_IMMOBILIZATION_DEVICES_USED_OPTIONS',
  SET_IMMOBILIZATION_OPTION_OPTIONS = 'options/SET_IMMOBILIZATION_OPTION_OPTIONS',
  SET_PHYSICIAN_OPTIONS = 'options/SET_PHYSICIAN_OPTIONS',
  SET_MEDICAL_CONSULT_METHOD_OPTIONS = 'options/SET_MEDICAL_CONSULT_METHOD_OPTIONS',
  SET_MEDICAL_CONSULT_FACILITY_OPTIONS = 'options/SET_MEDICAL_CONSULT_FACILITY_OPTIONS',
  SET_RESCUE_TYPES_OPTIONS = 'options/SET_RESCUE_TYPES_OPTIONS',
  SET_HYDRAULICS_OPTIONS = 'options/SET_HYDRAULICS_OPTIONS',
  SET_TOOLS_OPTIONS = 'options/SET_TOOLS_OPTIONS',
  SET_REHAB_OPTIONS = 'options/SET_REHAB_OPTIONS',
  SET_ACTIVATIONS_OPTIONS = 'options/SET_ACTIVATIONS_OPTIONS',
  SET_WOUND_CARE_ACTIONS_OPTIONS = 'options/SET_WOUND_CARE_ACTIONS_OPTIONS',
  SET_WOUND_CARE_SITE_OPTIONS = 'options/SET_WOUND_CARE_SITE_OPTIONS',
  SET_HOSPITAL_NOTIFY_METHOD_OPTIONS = 'options/SET_HOSPITAL_NOTIFY_METHOD_OPTIONS',
  SET_HOSPITAL_NOTIFY_ALERT_OPTIONS = 'options/SET_HOSPITAL_NOTIFY_ALERT_OPTIONS',
  SET_POTENTIAL_REGISTRY_OPTIONS = 'options/SET_POTENTIAL_REGISTRY_OPTIONS',
  SET_MODE_OPTIONS = 'options/SET_MODE_OPTIONS',
  SET_BREATH_TYPE_OPTIONS = 'options/SET_BREATH_TYPE_OPTIONS',
  SET_INDUSTRY_OPTIONS = 'options/SET_INDUSTRY_OPTIONS',
  SET_OCCUPATION_OPTIONS = 'options/SET_OCCUPATION_OPTIONS',

  SET_VENTILATOR_ACTIONS_OPTIONS = 'options/SET_VENTILATOR_ACTIONS_OPTIONS',
  SET_VENTILATOR_TEMPERTURE_UNIT_OPTIONS = 'options/SET_VENTILATOR_TEMPERTURE_UNIT_OPTIONS',
  SET_VENTILATOR_PREVSTATE = 'options/SET_VENTILATOR_PREVSTATE',

  SET_SECTION_OPTIONS = 'options/SET_SECTION_OPTIONS',
  SET_SIGNATURE_TYPE_OPTIONS = 'options/SET_SIGNATURE_TYPE_OPTIONS',
  SET_SIGNATURE_SEC_TWO_PATIENT_UNABLE_TO_SIGN_OPTIONS = 'options/SET_SIGNATURE_SEC_TWO_PATIENT_UNABLE_TO_SIGN_OPTIONS',
  SET_SECTION_ONE_TYPES = 'options/SET_SECTION_ONE_TYPES',
  SET_SECTION_TWO_TYPES = 'options/SET_SECTION_TWO_TYPES',
  SET_SECTION_THREE_TYPES = 'options/SET_SECTION_THREE_TYPES',
  SET_FORM_TEXT = 'options/SET_FORM_TEXT',
  RESET_FORM_TEXT = 'options/RESET_FORM_TEXT',
  SET_NIH_POSITIVE_STROKE_SCALE_QUESTION_ANSWERS = 'options/SET_NIH_POSITIVE_STROKE_SCALE_QUESTION_ANSWERS',
  SET_RACE_STROKE_SCALE_QUESTION_ANSWERS = 'options/SET_RACE_STROKE_SCALE_QUESTION_ANSWERS',
  SET_SERVICE_MODULES = 'options/SET_SERVICE_MODULES',
  SET_MEDICATIONS_ALLERGIES = 'options/SET_MEDICATIONS_ALLERGIES',
  SET_FOOD_ENVIRONMENTAL_ALLERGIES = 'options/SET_FOOD_ENVIRONMENTAL_ALLERGIES',
  SET_CAD_RECORDS = 'options/SET_CAD_RECORDS',
  SET_PHONE = 'options/SET_PHONE',
  SET_PHONE_TYPE = 'options/SET_PHONE_TYPE',
  SET_EMAIL = 'options/SET_EMAIL',
  SET_EMAIL_TYPE = 'options/SET_EMAIL_TYPE',
  DELETE_PHONE = 'options/DELETE_PHONE',
  DELETE_EMAIL = 'options/DELETE_EMAIL',
  SET_EMAIL_DETAIL = 'options/SET_EMAIL_DETAIL',
  SET_HOSPITAL_UNIT_OPTIONS = 'options/SET_HOSPITAL_UNIT_OPTIONS',
  SET_HOSPITAL_NAME_OPTIONS = 'options/SET_HOSPITAL_NAME_OPTIONS',
  SET_EMS_NAME_OPTIONS = 'options/SET_EMS_NAME_OPTIONS',
  SET_SCENE_GRID_OPTIONS = 'options/SET_SCENE_GRID_OPTIONS',
  SET_MODE_DESCRIPTORS_OPTIONS = 'options/SET_MODE_DESCRIPTORS_OPTIONS',
  SET_INITIAL_PATIENT_ACUITY_OPTIONS = 'options/SET_INITIAL_PATIENT_ACUITY_OPTIONS',
  SET_PATIENT_ACTIVITY_OPTIONS = 'options/SET_PATIENT_ACTIVITY_OPTIONS',
  SET_REASON_FOR_ENCOUNTER_OPTIONS = 'options/SET_REASON_FOR_ENCOUNTER_OPTIONS',
  SET_DRUGS_AND_ALCOHOL_OPTIONS = 'options/SET_DRUGS_AND_ALCOHOL_OPTIONS',
  SET_DRUGS_AND_ALCOHOL_INDICATORS_OPTIONS = 'options/SET_DRUGS_AND_ALCOHOL_INDICATORS_OPTIONS',
  SET_ARREST_PRESENT = 'options/SET_ARREST_PRESENT',
  SET_WHO_WITNESSED = 'options/SET_WHO_WITNESSED',
  SET_ETIOLOGY = 'options/SET_ETIOLOGY',
  SET_THERAPEUTIC_HYPOTHERMIA = 'options/SET_THERAPEUTIC_HYPOTHERMIA',
  SET_INITIAL_RHYTHM = 'options/SET_INITIAL_RHYTHM',
  SET_CPR_PRIOR_EMS_ARRIVAL = 'options/SET_CPR_PRIOR_EMS_ARRIVAL',
  SET_FIRST_CPR = 'options/SET_FIRST_CPR',
  SET_CPR_BY = 'options/SET_CPR_BY',
  SET_CPR_TYPE = 'options/SET_CPR_TYPE',
  SET_RESUSCITATION = 'options/SET_RESUSCITATION',
  SET_AED_USE = 'options/SET_AED_USE',
  SET_FIRST_AED_BY = 'options/SET_FIRST_AED_BY',
  SET_AED_BY = 'options/SET_AED_BY',
  SET_DEFIB_TYPE = 'options/SET_DEFIB_TYPE',
  SET_DEFIB_BY = 'options/SET_DEFIB_BY',
  SET_DISC_REASON = 'options/SET_DISC_REASON',
  SET_RETURN_CIRCULATION = 'options/SET_RETURN_CIRCULATION',
  SET_DEST_RHYTHM = 'options/SET_DEST_RHYTHM',
  SET_ARREST_RESULT = 'options/SET_ARREST_RESULT',
  SET_INTENTIONAL_OPTIONS = 'options/SET_INTENTIONAL_OPTIONs',
  SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_OPTIONS = 'options/SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_OPTIONS',
  SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_OPTIONS = 'options/SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_OPTIONS',
  SET_INJURY_CAUSE_OPTIONS = 'options/SET_INJURY_CAUSE_OPTIONS',
  SET_MECHANISM_OPTIONS = 'options/SET_MECHANISM_OPTIONS',
  SET_SAFETY_EQUIPMENT_OPTIONS = 'options/SET_SAFETY_EQUIPMENT_OPTIONS',
  SET_FALL_SURFACE_OPTIONS = 'options/SET_FALL_SURFACE_OPTIONS',
  SET_LANDED_ON_OPTIONS = 'options/SET_LANDED_ON_OPTIONS',
  SET_WORK_RELATED_OPTIONS = 'options/SET_WORK_RELATED_OPTIONS',
  SET_CC_DURATION_UNITS_OPTIONS = 'options/SET_CC_DURATION_UNITS_OPTIONS',
  SET_SC_DURATION_UNITS_OPTIONS = 'options/SET_SC_DURATION_UNITS_OPTIONS',
  SET_OC_DURATION_UNITS_OPTIONS = 'options/SET_OC_DURATION_UNITS_OPTIONS',
  RESET_CAD_RECORDS = 'options/RESET_CAD_RECORDS',
  RESET_PATIENT_ALLERGIES_OPTIONS = 'options/RESET_PATIENT_ALLERGIES_OPTIONS',
  SET_SELECTED_CREW_MEMBERS = 'options/SET_SELECTED_CREW_MEMBERS',
  SET_DESTINATION_BASIS_OPTIONS = 'options/SET_DESTINATION_BASIS_OPTIONS',
  SET_DESTINATION_MODE_DESCRIPTORS_OPTIONS = 'options/SET_DESTINATION_MODE_DESCRIPTORS_OPTIONS',
  SET_CAPABILITIES_OPTIONS = 'options/SET_CAPABILITIES_OPTIONS',
  SET_TIME_ZONE_OPTIONS = 'options/SET_TIME_ZONE_OPTIONS',
  SET_DESTINATION_HOSPITAL_OPTIONS = 'options/SET_DESTINATION_HOSPITAL_OPTIONS',
  SET_DESTINATION_EMS_OPTIONS = 'options/SET_DESTINATION_EMS_OPTIONS',
  SET_DESTINATION_TRANSPORT_MODE_OPTIONS = 'options/SET_DESTINATION_TRANSPORT_MODE_OPTIONS',
  SET_PRIORITY_OPTIONS = 'options/SET_PRIORITY_OPTIONS',
  SET_INSURED_OPTIONS = 'options/SET_INSURED_OPTIONS',
  SET_RELATIONSHIP_OPTIONS = 'options/SET_RELATIONSHIP_OPTIONS',
  SET_PCS_INFORMATION_OPTIONS = 'options/SET_PCS_INFORMATION_OPTIONS',
  SET_NPP_FORM_OPTIONS = 'options/SET_NPP_FORM_OPTIONS',
  SET_CONSENT_FORM_SIGNED_OPTIONS = 'options/SET_CONSENT_FORM_SIGNED_OPTIONS',
  SET_MEDICAL_NECESSITY_SIGNED_OPTIONS = 'options/SET_MEDICAL_NECESSITY_SIGNED_OPTIONS',
  SET_PCS_REASON_OPTIONS = 'options/SET_PCS_REASON_OPTIONS',
  SET_PCS_PROVIDER_TYPE_OPTIONS = 'options/SET_PCS_PROVIDER_TYPE_OPTIONS',
  SET_CMS_CONDITION_CODE_OPTIONS = 'options/SET_CMS_CONDITION_CODE_OPTIONS',
  SET_FILTER_CMS_CONDITION_CODE_OPTIONS = 'options/SET_FILTER_CMS_CONDITION_CODE_OPTIONS',
  SET_CONDITION_CODE_MODIFIER_OPTIONS = 'options/SET_CONDITION_CODE_MODIFIER_OPTIONS',
  SET_CMS_TRANSPORT_REASON_OPTIONS = 'options/SET_CMS_TRANSPORT_REASON_OPTIONS',
  SET_AMBULANCE_CONDITION_INDICATOR_OPTIONS = 'options/SET_AMBULANCE_CONDITION_INDICATOR_OPTIONS',
  SET_PRIMARY_PAYMENT_METHOD_OPTIONS = 'options/SET_PRIMARY_PAYMENT_METHOD_OPTIONS',
  SET_X12_PAYER_TYPE_OPTIONS = 'options/SET_X12_PAYER_TYPE_OPTIONS',
  SET_PRIOR_AUTHORIZATION_PAYER_OPTIONS = 'options/SET_PRIOR_AUTHORIZATION_PAYER_OPTIONS',
  SET_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC = 'options/SET_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC',
  SET_FULL_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC = 'options/SET_FULL_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC',
  SET_GUARANTORS_AGE_OPTIONS = 'options/SET_GUARANTORS_AGE_OPTIONS',
  RESET_INSURED_OPTIONS = 'options/RESET_INSURED_OPTIONS',
  SET_CAMERA_ATTACHMENTS_CATEGORY_OPTIONS = 'options/SET_CAMERA_ATTACHMENTS_CATEGORY_OPTIONS',
  SET_CUSTOM_SIGNATURE_OPTIONS = 'options/SET_CUSTOM_SIGNATURE_OPTIONS',
  SET_CUSTOM_SIGNATURE_TYPE_OPTIONS = 'options/SET_CUSTOM_SIGNATURE_TYPE_OPTIONS',
  SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE_OPTIONS = 'options/SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE_OPTIONS',
  SET_CUSTOM_SIGNATURE_TRANSFORMED_OPTIONS = 'options/SET_CUSTOM_SIGNATURE_TRANSFORMED_OPTIONS',
  SET_DISPATCH_FACTORS_OPTIONS = 'options/SET_DISPATCH_FACTORS_OPTIONS',
  SET_RESPONSE_FACTORS_OPTIONS = 'options/SET_RESPONSE_FACTORS_OPTIONS',
  SET_SCENE_FACTORS_OPTIONS = 'options/SET_SCENE_FACTORS_OPTIONS',
  SET_TRANSPORT_FACTORS_OPTIONS = 'options/SET_TRANSPORT_FACTORS_OPTIONS',
  SET_TURN_AROUND_FACTORS_OPTIONS = 'options/SET_TURN_AROUND_FACTORS_OPTIONS',
  SET_FACTORS_OPTIONS = 'options/SET_FACTORS_OPTIONS',
  SET_PACING_MODE_OPTIONS = 'options/SET_PACING_MODE_OPTIONS',
  SET_COMPRESSION_RATE_OPTIONS = 'options/SET_COMPRESSION_RATE_OPTIONS',
  SET_LOCATION_OPTIONS = 'options/SET_LOCATION_OPTIONS',
  SET_MECHANICAL_CPR_TYPE_OPTIONS = 'options/SET_MECHANICAL_CPR_TYPE',
  SET_FIRST_ON_SCENE_OPTIONS = 'options/SET_FIRST_ON_SCENE_OPTIONS',
  SET_LEVEL_CARE_PER_PROTOCOL_OPTIONS = 'options/SET_LEVEL_CARE_PER_PROTOCOL_OPTIONS',
  SET_PR_OTHER_AGENCIES_OPTIONS = 'options/SET_PR_OTHER_AGENCIES_OPTIONS',
  SET_TRANSFER_OF_CARE_OPTIONS = 'options/SET_TRANSFER_OF_CARE_OPTIONS',
  SET_PR_DISASTER_OPTIONS = 'options/SET_PR_DISASTER_OPTIONS',
  SET_PR_PT_MOVED_VIA_OPTIONS = 'options/SET_PR_PT_MOVED_VIA_OPTIONS',
  SET_PR_PT_POSITION_OPTIONS = 'options/SET_PR_PT_POSITION_OPTIONS',
  SET_PR_PT_MOVED_FROM_OPTIONS = 'options/SET_PR_PT_MOVED_FROM_OPTIONS',
  SET_PR_TRANSPORT_ASSESS_OPTIONS = 'options/SET_PR_TRANSPORT_ASSESS_OPTIONS',
  SET_PR_DISPO_INSTRUCTIONS_OPTIONS = 'options/SET_PR_DISPO_INSTRUCTIONS_OPTIONS',
  SET_AIR_STATUS_OPTIONS = 'options/SET_AIR_STATUS_OPTIONS',
  SET_AIR_TYPE_OPTIONS = 'options/SET_AIR_TYPE_OPTIONS',
  SET_AIR_ETT_SIZE_UNIT_OPTIONS = 'options/SET_AIR_ETT_SIZE_UNIT_OPTIONS',
  SET_AIR_BY_OPTIONS = 'options/SET_AIR_BY_OPTIONS',
  SET_AIR_OUTCOME_OPTIONS = 'options/SET_AIR_OUTCOME_OPTIONS',
  SET_AIRWAY_VERIFICATION_ASSESS_OPTIONS = 'options/SET_AIRWAY_VERIFICATION_ASSESS_OPTIONS',
  SET_AIRWAY_ASSESS_OPTIONS = 'options/SET_AIRWAY_ASSESS_OPTIONS',
  SET_AIRWAY_BROSELOW_OPTIONS = 'options/SET_AIRWAY_BROSELOW_OPTIONS',
  SET_BREATH_SOUND_LEFT_OPTIONS = 'options/SET_BREATH_SOUND_LEFT_OPTIONS',
  SET_BREATH_SOUND_RIGHT_OPTIONS = 'options/SET_BREATH_SOUND_RIGHT_OPTIONS',
  SET_RESP_EFFORT_OPTIONS = 'options/SET_RESP_EFFORT_OPTIONS',
  SET_RESP_VIA_OPTIONS = 'options/SET_RESP_VIA_OPTIONS',
  SET_RESP_PERFORM_BY_OPTIONS = 'options/SET_RESP_PERFORM_BY_OPTIONS',
  SET_RESP_OUTCOME_OPTIONS = 'options/SET_RESP_OUTCOME_OPTIONS',
  SET_RESP_EXAM_OPTIONS = 'options/SET_RESP_EXAM_OPTIONS',
  SET_MOTOROPTIONS = 'options/SET_MOTOROPTIONS',
  SET_SENSORYOPTIONS = 'options/SET_SENSORYOPTIONS',
  SET_PUPILSSIZEOPTIONS = 'options/SET_PUPILSSIZEOPTIONS',
  SET_PUPILSREACTOPTIONS = 'options/SET_PUPILSREACTOPTIONS',
  SET_HEADCONCIOUSNESSOPTIONS = 'options/SET_HEADCONCIOUSNESSOPTIONS',
  SET_THROMSCREENOPTIONS = 'options/SET_THROMSCREENOPTIONS',
  SET_STROKESCALENEUROOPTIONS = 'options/SET_STROKESCALENEUROOPTIONS',
  SET_STROKECVASYMPTOMSRESOLVEDOPTIONS = 'options/SET_STROKECVASYMPTOMSRESOLVEDOPTIONS',
  SET_HEADLOSSCONSOPTIONS = 'options/SET_HEADLOSSCONSOPTIONS',
  SET_PTS_SIZE_OPTIONS = 'options/SET_PTS_SIZE_OPTIONS',
  SET_PTS_AIR_OPTIONS = 'options/SET_PTS_AIR_OPTIONS',
  SET_PTS_BP_OPTIONS = 'options/SET_PTS_BP_OPTIONS',
  SET_PTS_CNS_OPTIONS = 'options/SET_PTS_CNS_OPTIONS',
  SET_PTS_SKEL_OPTIONS = 'options/SET_PTS_SKEL_OPTIONS',
  SET_PTS_WOUND_OPTIONS = 'options/SET_PTS_WOUND_OPTIONS',
  SET_RTS_SYS_BP_OPTIONS = 'options/SET_RTS_SYS_BP_OPTIONS',
  SET_RTS_RESP_RATE_OPTIONS = 'options/SET_RTS_RESP_RATE_OPTIONS',
  SET_PATIENT_WAS_IMMOBILIZED_PERFORMED_BY = 'options/SET_PATIENT_WAS_IMMOBILIZED_PERFORMED_BY',
  SET_PATIENT_WAS_IMMOBILIZED_OUTCOME = 'options/SET_PATIENT_WAS_IMMOBILIZED_OUTCOME',
  SET_GCS_QUALIFIER = 'options/SET_GCS_QUALIFIER',
  SET_GCS_EYE_RESPONSE = 'options/SET_GCS_EYE_RESPONSE',
  SET_GCS_VERBAL_RESPONSE = 'options/SET_GCS_VERBAL_RESPONSE',
  SET_GCS_MOTOR_RESPONSE = 'options/SET_GCS_MOTOR_RESPONSE',
  SET_PULSES_OPTIONS = 'options/SET_PULSES_OPTIONS',
  SET_PR_CV_ASSESS_OPTIONS = 'options/SET_PR_CV_ASSESS_OPTIONS',
  SET_CV_TEMP_METHOD_OPTIONS = 'options/SET_CV_TEMP_METHOD_OPTIONS',
  SET_CV_JVD_OPTIONS = 'options/SET_CV_JVD_OPTIONS',
  SET_CV_CAP_REFILL_OPTIONS = 'options/SET_CV_CAP_REFILL_OPTIONS',
  SET_CV_EDEMA_OPTIONS = 'options/SET_CV_EDEMA_OPTIONS',
  SET_CV_ART_OPTIONS = 'options/SET_CV_ART_OPTIONS',
  SET_CV_SWAN_OPTIONS = 'options/SET_CV_SWAN_OPTIONS',
  SET_PM_TYPE_OPTIONS = 'options/SET_PM_TYPE_OPTIONS',
  SET_NEURO_STROKE_SCALE_SCORE_OPTIONS = 'options/SET_NEURO_STROKE_SCALE_SCORE_OPTIONS',
  SET_STROKE_SCALE_CONFIG_OPTIONS = 'options/SET_STROKE_SCALE_CONFIG_OPTIONS',
  SET_NEURO_CUSTOM_STROKE_SCALE_SCORE_OPTIONS = 'options/SET_NEURO_CUSTOM_STROKE_SCALE_SCORE_OPTIONS',
  SET_VITALS_CUSTOM_STROKE_SCALE_SCORE_OPTIONS = 'options/SET_VITALS_CUSTOM_STROKE_SCALE_SCORE_OPTIONS',
  SET_JOINT_COMMISSION_TIMEOUT_OPTIONS = 'options/SET_JOINT_COMMISSION_TIMEOUT_OPTIONS',
  SET_LABS_CONFIG_OPTIONS = 'options/SET_LABS_CONFIG_OPTIONS',
  SET_ABG_ACCESS_OPTIONS = 'options/SET_ABG_ACCESS_OPTIONS',
  SET_PN_PROCEDURE_OPTIONS = 'options/SET_PN_PROCEDURE_OPTIONS',
  SET_REFUSAL_RELEASE_REASON_OPTIONS = 'options/SET_REFUSAL_RELEASE_REASON_OPTIONS',
  SET_TRANSPORT_DISPOSITION_OPTIONS = 'options/SET_TRANSPORT_DISPOSITION_OPTIONS',
  SET_CREW_DISPOSITION_OPTIONS = 'options/SET_CREW_DISPOSITION_OPTIONS',
  SET_PATIENT_EVALUATION_OPTIONS = 'options/SET_PATIENT_EVALUATION_OPTIONS',
  SET_UNIT_DISPOSITION_OPTIONS = 'options/SET_UNIT_DISPOSITION_OPTIONS',
  SET_EXPOSURE_EQUIPMENT_OPTIONS = 'options/SET_EXPOSURE_EQUIPMENT_OPTIONS',
  SET_EXPOSURE_TYPE_OPTIONS = 'options/SET_EXPOSURE_TYPE_OPTIONS',
  SET_EXPOSED_TO_OPTIONS = 'options/SET_EXPOSED_TO_OPTIONS',
  SET_EXPOSURE_CREW = 'options/SET_EXPOSURE_CREW',
  SET_SUSPECTED_EXPOSURE = 'options/SET_SUSPECTED_EXPOSURE',
  SET_PHYSICIAN_TYPE_OPTIONS = 'options/SET_PHYSICIAN_TYPE_OPTIONS',
  SET_AIRBAG_DEPLOYED_OPTIONS = 'options/SET_AIRBAG_DEPLOYED_OPTIONS',
  SET_VEHICLE_IMPACT_SITE_OPTIONS = 'options/SET_VEHICLE_IMPAT_SITE_OPTIONS',
  SET_LOCATION_OF_PATIENT_IN_VEHICLE_OPTIONS = 'options/SET_LOCATION_OF_PATIENT_IN_VEHICLE_OPTIONS',
  SET_EXTRICATION_REQUIRED_OPTIONS = 'options/SET_EXTRICATION_REQUIRED_OPTIONS',
  SET_IMMUNIZATION_STATUS_OPTIONS = 'options/SET_IMMUNIZATION_STATUS_OPTIONS',
  SET_IMMUNIZATION_TYPE_OPTIONS = 'options/SET_IMMUNIZATION_TYPE_OPTIONS',
  SET_IMMUNIZATION_YEAR_OPTIONS = 'options/SET_IMMUNIZATION_YEAR_OPTIONS',

  SET_RULES_OPTIONS = 'options/SET_RULES_OPTIONS',
  SET_STATE_RULES = 'options/SET_STATE_RULES',
  SET_SERVICE_RULES = 'options/SET_SERVICE_RULES',
  SET_RULES_UTILS_MODULE = 'options/SET_RULES_UTILS_MODULE',

  SET_SYSTEM_OPTIONS = 'options/SET_SYSTEM_OPTIONS',
  SET_SYMPTOMS_OPTIONS = 'options/SET_SYMPTOMS_OPTIONS',
  SET_IMPRESSIONS_OPTIONS = 'options/SET_IMPRESSIONS_OPTIONS',
  SET_ANATOMIC_LOCATION_OPTIONS = 'options/SET_ANATOMIC_LOCATION_OPTIONS',
  SET_CONDITION_AT_DEST_OPTIONS = 'options/SET_CONDITION_AT_DEST_OPTIONS',
  SET_FINAL_PATIENT_ACUITY_OPTIONS = 'options/SET_FINAL_PATIENT_ACUITY_OPTIONS',

  SET_IS_PATIENT_PREGNANT_OPTIONS = 'options/SET_IS_PATIENT_PREGNANT_OPTIONS',
  SET_BLOODY_SHOW_OPTIONS = 'options/SET_BLOODY_SHOW_OPTIONS',
  SET_PRENATAL_CARE_OPTIONS = 'options/SET_PRENATAL_CARE_OPTIONS',
  SET_MEMBRANES_AMNIOTIC_FLUID_OPTIONS = 'options/SET_MEMBRANES_AMNIOTIC_FLUID_OPTIONS',
  SET_DYNAMIC_RANGE_OPTIONS = 'options/SET_DYNAMIC_RANGE_OPTIONS',
  SET_MATERNAL_MEDICATIONS_ADMINISTERED_OPTIONS = 'options/SET_MATERNAL_MEDICATIONS_ADMINISTERED_OPTIONS',
  SET_BURN_TYPE_OPTIONS = 'options/SET_BURN_TYPE_OPTIONS',
  SET_BODY_SURVEY_EXAM_OPTIONS = 'options/SET_BODY_SURVEY_EXAM_OPTIONS',
  SET_BODY_SURVEY_SELECTED_EXAM_OPTIONS = 'options/SET_BODY_SURVEY_SELECTED_EXAM_OPTIONS',
  SET_BODY_SURVEY_BODY_PARTS_OPTIONS = 'options/SET_BODY_SURVEY_BODY_PARTS_OPTIONS',
  SET_BODY_SURVEY_GENERAL_EXTREMITIES_OPTIONS = 'options/SET_BODY_SURVEY_GENERAL_EXTREMITIES_OPTIONS',
  SET_BODY_SURVEY_SKIN_OPTIONS = 'options/SET_BODY_SURVEY_SKIN_OPTIONS',
  SET_BODY_SURVEY_CARDIAC_OPTIONS = 'options/SET_BODY_SURVEY_CARDIAC_OPTIONS',
  SET_BODY_SURVEY_NEURO_OPTIONS = 'options/SET_BODY_SURVEY_NEURO_OPTIONS',
  SET_BODY_SURVEY_MENTAL_OPTIONS = 'options/SET_BODY_SURVEY_MENTAL_OPTIONS',
  SET_ASSESSMENT_DEFAULT_OPTIONS = 'options/SET_ASSESSMENT_DEFAULT_OPTIONS',
  SET_ALS_ASSESSMENT_OPTIONS = 'options/SET_ALS_ASSESSMENT_OPTIONS',
  SET_NEURO_GAZE_OPTIONS = 'options/SET_NEURO_GAZE_OPTIONS',
  SET_NEURO_LIMB_OPTIONS = 'options/SET_NEURO_LIMB_OPTIONS',
  SET_NEURO_SPEECH_OPTIONS = 'options/SET_NEURO_SPEECH_OPTIONS',
  SET_NEURO_FACIAL_OPTIONS = 'options/SET_NEURO_FACIAL_OPTIONS',
  SET_NEURO_MOTOR_OPTIONS = 'options/SET_NEURO_MOTOR_OPTIONS',
  SET_ASSESSMENT_ACTION_OPTIONS = 'options/SET_ASSESSMENT_ACTION_OPTIONS',
  SET_SEPSIS_INDICATORS_OPTIONS = 'options/SET_SEPSIS_INDICATORS_OPTIONS',
  SET_CUSTOM_ACTION_FIELDS_OPTIONS = 'options/SET_CUSTOM_ACTION_FIELDS_OPTIONS',
  SET_CUSTOM_ACTION_FIELDS_ANSWERS_OPTIONS = 'options/SET_CUSTOM_ACTION_FIELDS_ANSWERS_OPTIONS',
  SET_ALL_PNNV_OPTIONS = 'options/SET_ALL_PNNV_OPTIONS',
  SET_COMMON_ADDRESSES_OPTIONS = 'options/SET_COMMON_ADDRESSES_OPTIONS',
  SET_OTHER_AGENCY_NAME_OPTIONS = 'options/SET_OTHER_AGENCY_NAME_OPTIONS',
  SET_OTHER_AGENCY_TYPE_OPTIONS = 'options/SET_OTHER_AGENCY_TYPE_OPTIONS',
  SET_REASONS_FOR_FAILURE_OPTIONS = 'options/SET_REASONS_FOR_FAILURE_OPTIONS',
  SET_RESPONSE_MODE_CUSTOM_OPTIONS = 'options/SET_RESPONSE_MODE_CUSTOM_OPTIONS',
  SET_DESTINATION_TRANSPORT_MODE_CUSTOM_OPTIONS = 'options/SET_DESTINATION_TRANSPORT_MODE_CUSTOM_OPTIONS',
  SET_CALL_TYPE_OPTIONS = 'options/SET_CALL_TYPE_OPTIONS',
  SET_NEMSIS_CUSTOM_OPTIONS = 'options/SET_NEMSIS_CUSTOM_OPTIONS',
  SET_NEMSIS_CUSTOM_CONFIG_GROUPS = 'options/SET_NEMSIS_CUSTOM_CONFIG_GROUPS',
  SET_HIDE_NEMSIS_CUSTOM_OPTION = 'options/SET_HIDE_NEMSIS_CUSTOM_OPTION',

  SET_PT_ID_VERIFIED_OPTIONS = 'options/SET_PT_ID_VERIFIED_OPTIONS',
  SET_CLINICAL_INDICATOR_OPTIONS = 'options/SET_CLINICAL_INDICATOR_OPTIONS',
  SET_CROSS_MATCHED_OPTIONS = 'options/SET_CROSS_MATCHED_OPTIONS',
  SET_TRANSFUSION_CONSENT_OPTIONS = 'options/SET_TRANSFUSION_CONSENT_OPTIONS',
  SET_BLOOD_PRODUCT_TYPE_OPTIONS = 'options/SET_BLOOD_PRODUCT_TYPE_OPTIONS',
  SET_BLOOD_PRODUCT_OPTIONS = 'options/SET_BLOOD_PRODUCT_OPTIONS',
  SET_BLOOD_PRODUCT_ROUTE_OPTIONS = 'options/SET_BLOOD_PRODUCT_ROUTE_OPTIONS',
  SET_TRANSFUSION_ORDER_OPTIONS = 'options/SET_TRANSFUSION_ORDER_OPTIONS',
  SET_IMPLIED_EMERGENT_CONSENT_REASON_OPTIONS = 'options/SET_IMPLIED_EMERGENT_CONSENT_REASON_OPTIONS',

  SET_VAD_TYPE_OPTIONS = 'options/SET_VAD_TYPE_OPTIONS',
  SET_VAD_ALARMS_OPTIONS = 'options/SET_VAD_ALARMS_OPTIONS',
  SET_VAD_SITE_ASSESSMENT_OPTIONS = 'options/SET_VAD_SITE_ASSESSMENT_OPTIONS',
  SET_VAD_CATHETER_SIZE_OPTIONS = 'options/SET_VAD_CATHETER_SIZE_OPTIONS',
  SET_VAD_PLACEMENT_CONFIRMED_BY_OPTIONS = 'options/SET_VAD_PLACEMENT_CONFIRMED_BY_OPTIONS',
  SET_VAD_INSERT_LOCATION_OPTIONS = 'options/SET_VAD_INSERT_LOCATION_OPTIONS',
  SET_VAD_MOTOR_CURRENT_WAVEFORM_CHARACTERISTICS_OPTIONS = 'options/SET_VAD_MOTOR_CURRENT_WAVEFORM_CHARACTERISTICS_OPTIONS',
  SET_VAD_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS_OPTIONS = 'options/SET_VAD_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS_OPTIONS',
  SET_VAD_PLACEMENT_LOCATION_OPTIONS = 'options/SET_VAD_PLACEMENT_LOCATION_OPTIONS',
  SET_VAD_POWER_TYPE_OPTIONS = 'options/SET_VAD_POWER_TYPE_OPTIONS',
  SET_VAD_BACKUP_OPTIONS_OPTIONS = 'options/SET_VAD_BACKUP_OPTIONS_OPTIONS',
  SET_VAD_BATTERY_STATUS_OPTIONS = 'options/SET_VAD_BATTERY_STATUS_OPTIONS',
  SET_VAD_FLOW_TYPE_OPTIONS = 'options/SET_VAD_FLOW_TYPE_OPTIONS',
  SET_VAD_INDICATION_OPTIONS = 'options/SET_VAD_INDICATION_OPTIONS',
  SET_VAD_MAKE_MODEL_OPTIONS = 'options/SET_VAD_MAKE_MODEL_OPTIONS',
  SET_VAD_MAKE_MODEL_IMPELLA_OPTIONS = 'options/SET_VAD_MAKE_MODEL_IMPELLA_OPTIONS',

  SET_YES_NO_OPTIONS = 'options/SET_YES_NO_OPTIONS',
  SET_CRITICAL_CARE_SITE_OPTIONS_DOC = 'options/SET_CRITICAL_CARE_SITE_OPTIONS_DOC',
  SET_IABP_AUGMENTATION_OPTIONS_DOC = 'options/SET_IABP_AUGMENTATION_OPTIONS_DOC',
  SET_TASK_OPTIONS_DOC = 'options/SET_TASK_OPTIONS_DOC',
  SET_IABP_FREQUENCY_OPTIONS_DOC = 'options/SET_IABP_FREQUENCY_OPTIONS_DOC',
  SET_INSERTION_SITE_OPTIONS_DOC = 'options/SET_INSERTION_SITE_OPTIONS_DOC',
  SET_TRIGGER_UTILIZED_OPTIONS_DOC = 'options/SET_TRIGGER_UTILIZED_OPTIONS_DOC',
  SET_CRITICAL_CARE_ACTION_OPTIONS_DOC = 'options/SET_CRITICAL_CARE_ACTION_OPTIONS_DOC',
  SET_SLOW_GAS_LEAK_OPTIONS_DOC = 'options/SET_SLOW_GAS_LEAK_OPTIONS_DOC',
  SET_AUTO_MANUAL_OPTIONS_DOC = 'options/SET_AUTO_MANUAL_OPTIONS_DOC',
  SET_SCT_PROCS_OPTIONS = 'options/SET_SCT_PROCS_OPTIONS',
  SET_SCT_MEDS_OPTIONS = 'options/SET_SCT_MEDS_OPTIONS',
  SET_CUSTOM_FLUIDS_OPTIONS = 'options/SET_CUSTOM_FLUIDS_OPTIONS',
  SET_APGAR_APPEARANCE_OPTIONS = 'options/SET_APGAR_APPEARANCE_OPTIONS',
  SET_APGAR_PULSE_OPTIONS = 'options/SET_APGAR_PULSE_OPTIONS',
  SET_APGAR_GRIMACE_OPTIONS = 'options/SET_APGAR_GRIMACE_OPTIONS',
  SET_APGAR_ACTIVITY_OPTIONS = 'options/SET_APGAR_ACTIVITY_OPTIONS',
  SET_APGAR_RESPIRATION_OPTIONS = 'options/SET_APGAR_RESPIRATION_OPTIONS',
  SET_TEAM_OPTIONS = 'options/SET_TEAM_OPTIONS',
  SET_TEAM_CARE_ONLY_OPTIONS = 'options/SET_TEAM_CARE_ONLY_OPTIONS',
  SET_EQUIPMENT_OPTIONS = 'options/SET_EQUIPMENT_OPTIONS',
  SET_PROVIDER_ROLES_OPTIONS = 'options/SET_PROVIDER_ROLES_OPTIONS',
  SET_ADMINISTERED_BY_OTHER_UNIT_OPTIONS = 'options/SET_ADMINISTERED_BY_OTHER_UNIT_OPTIONS',
  SET_DT_WITNESSED_PNNV_OPTIONS = 'options/SET_DT_WITNESSED_PNNV_OPTIONS',
  GET_SPECIAL_REPORT_DATA = 'options/GET_SPECIAL_REPORT_DATA',
  SET_SPECIAL_REPORT_DATA = 'options/SET_SPECIAL_REPORT_DATA',
  SET_SPECIAL_REPORT_CATEGORIES = 'options/SET_SPECIAL_REPORT_CATEGORIES',
  SET_SPECIAL_REPORT_SUB_CATEGORIES = 'options/SET_SPECIAL_REPORT_SUB_CATEGORIES',
  SET_FILLABLE_PDF_METADATA = 'options/SET_FILLABLE_PDF_METADATA',
  SET_FILLABLE_PDF_BINDINGS = 'options/SET_FILLABLE_PDF_BINDINGS',
  SET_PULSARA_DATE_RANGE_OPTIONS = 'options/SET_PULSARA_DATE_RANGE_OPTIONS',
  SET_FLIGHT_PLAN_OPTIONS = 'options/SET_FLIGHT_PLAN_OPTIONS',
}
